import { siteClearance } from '@utils/clearanceHelpers'
import store from '@state/store'

import collaboratorsV2 from './collaborators'
import { federatedLoginGuard } from '@/router/guards/auth.guard'
import homeV2 from './home'
import planningRoutesV2 from './planning'

function resolveDefaultHomeRoute() {
  const actorRole = store.state.auth.actorRoles
  const siteCode = actorRole?.site
  const collaboratorId = store.state.auth.currentUser?.uuid

  if (!actorRole?.code) return '/logout'

  if (siteClearance.admin.includes(actorRole.code)) {
    return { name: 'mexico-map' }
  }

  if (siteClearance.director.includes(actorRole.code)) {
    if (!siteCode) return '/logout'
    return { path: `/mx/${siteCode}/collaborators` }
  }

  if (siteClearance.collaboratorServices.includes(actorRole.code)) {
    return { path: `/mx/${siteCode}/collaborator-home` }
  }

  if (siteClearance.collaborator.includes(actorRole.code)) {
    if (!collaboratorId) return '/logout'
    return { path: `/mx/monthPlanning/${collaboratorId}` }
  }

  if (siteClearance.responsible.includes(actorRole.code)) {
    return { path: `/mx/${siteCode}/collaborators` }
  }

  if (!siteCode) return '/logout'

  return '/logout'
}

export default [
  ...planningRoutesV2,
  ...collaboratorsV2,
  ...homeV2,
  {
    path: '/',
    beforeResolve: (to, from, next) => {
      store.dispatch('collaborator/RESET_COLLABORATOR_STATE()')
      next() // decide view to redirect when user access directly without verification
    },
    redirect: () => resolveDefaultHomeRoute(),
    meta: {
      authRequired: true,
      authorize: [],
    },
  },
  {
    path: '/exit-survey/:token',
    name: 'exitSurvey',
    component: () => import('@/modules/surveys/views/exit-survey/exit-survey.vue'),
  },
  // ///////////////////
  // COLLABORATOR ROUTES
  // ///////////////////
  // {
  //   path: '/collaborators',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  //   children: [
  //     {
  //       path: 'zoneDirectorSites',
  //       name: 'zone-director-sites',
  //       component: () => import('@views/collaborator/zone-director-sites/zone-director-sites.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin],
  //       },
  //     },
  //     {
  //       path: 'deletedCollaborators',
  //       name: 'collaborator-list-deleted',
  //       component: () => import('@views/collaborator/collaborator-list/collaborator-list-deleted.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin],
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/mx/:personnelDivision/collaborators',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: 'deletedCollaborators',
  //       name: 'collaborator-list-deleted-site',
  //       component: () => import('@views/collaborator/collaborator-list/collaborator-list-deleted-site.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: ':collaboratorUuid',
  //       name: 'collaborator-site-info',
  //       component: () => import('@views/collaborator/collaborator-info/collaborator-info.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [
  //           ...siteClearance.admin,

  //           ...siteClearance.director,
  //           ...siteClearance.responsible,
  //           ...siteClearance.collaborator,
  //           ...siteClearance.responsible,
  //         ],
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/mx/:collaboratorUuid/selectRehireable/:processUuid',
  //   name: 'select-rehireable',
  //   component: () => import('@views/leave/select-rehireable/select-rehireable.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/collaborators/:collaboratorUuid/document/',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: 'contract/:contractStartDate',
  //       name: 'collaborator-contract-basic-document',
  //       component: () => import('@views/contract/document/contract-basic-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [
  //           ...siteClearance.admin,

  //           ...siteClearance.director,
  //           ...siteClearance.responsible,
  //           ...siteClearance.collaborator,
  //           ...siteClearance.responsible,
  //         ],
  //       },
  //     },
  //     {
  //       path: 'endOfContract',
  //       name: 'collaborator-end-of-contract-document',
  //       component: () => import('@views/contract/document/end-of-contract-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'notPassedTrial',
  //       name: 'collaborator-not-passed-trial-document',
  //       component: () => import('@views/contract/document/not-passed-trial-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'conversion',
  //       name: 'collaborator-conversion-document',
  //       component: () => import('@views/contract/document/conversion-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'extension',
  //       name: 'collaborator-extension-document',
  //       component: () => import('@views/contract/document/extension-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'mutation',
  //       name: 'collaborator-mutation-document',
  //       component: () => import('@views/contract/document/mutation-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'mutationTraining',
  //       name: 'collaborator-mutation-training-document',
  //       component: () => import('@views/contract/document/mutation-training-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'cityBonus',
  //       name: 'collaborator-cityBonus-document',
  //       component: () => import('@views/contract/document/city-bonus-document.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //   ],
  // },
  // /////////////////
  // PARAMETERS ROUTES
  // /////////////////
  // {
  //   path: '/parameters',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'parameter-list',
  //       component: () => import('@views/common/parameters/parameter-list.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'new',
  //       name: 'parameter-new',
  //       component: () => import('@views/common/parameters/parameter-new.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: siteClearance.admin,
  //       },
  //     },
  //     {
  //       path: ':id',
  //       name: 'parameter-edit',
  //       component: () => import('@views/common/parameters/parameter-edit.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: siteClearance.admin,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/rehiring/rehiringProcesses',
  //   name: 'rehiring-processes',
  //   component: () => import('@views/rehiring/rehiring-processes/rehiring-processes.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // /////////////////////////////
  // GENERAL OPEN PROCESSES ROUTES
  // ////////////////////////////
  // {
  //   path: '/general/openProcesses',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'common-contract-processes',
  //       component: () => import('@views/common/open-processes/open-processes.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin],
  //       },
  //     },
  //     {
  //       path: ':processUuid',
  //       component: () => import('@views/empty-router-view.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin],
  //       },
  //       children: [
  //         {
  //           path: '',
  //           name: 'open-process-details',
  //           component: () => import('@views/common/open-processes/open-process-details.vue'),
  //           meta: {
  //             authRequired: true,
  //             authorize: [...siteClearance.admin],
  //           },
  //         },
  //         {
  //           path: 'manualAssignIdentity',
  //           name: 'manual-assign-identity',
  //           component: () => import('@views/hiring/identity/manual-assign-identity.vue'),
  //           meta: {
  //             authRequired: true,
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  // //////////////////////////////////
  // SITE GENERAL OPEN PROCESSES ROUTES
  // //////////////////////////////////
  // {
  //   path: '/mx/:personnelDivision/general/openProcesses',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'open-processes-site',
  //       component: () => import('@views/common/open-processes/open-processes-site.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: ':processUuid',
  //       component: () => import('@views/empty-router-view.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //       children: [
  //         {
  //           path: '',
  //           name: 'site-open-process-details',
  //           component: () => import('@views/common/open-processes/open-process-details-site.vue'),
  //           meta: {
  //             authRequired: true,
  //             authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //           },
  //         },
  //         {
  //           path: 'manualAssignIdentity',
  //           name: 'site-manual-assign-identity',
  //           component: () => import('@views/hiring/identity/manual-assign-identity.vue'),
  //           meta: {
  //             authRequired: true,
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  // //////////////////
  // INVITATION ROUTES
  // /////////////////
  // {
  //   path: '/mx/:personnelDivision/invitations',
  //   name: 'invitations-list',
  //   component: () => import('@views/hiring/invitations/invitations-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/invitation/:rfc',
  //   name: 'view-invitation',
  //   component: () => import('@views/hiring/invitations/invitation-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },

  // ///////////
  // ==========
  // //////////
  // ///////////////////
  // SITE HIRING ROUTES
  // //////////////////
  // {
  //   path: '/mx/:personnelDivision/hiring',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'site-id-check',
  //       component: () => import('@views/hiring/id-check/id-check.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [
  //           ...siteClearance.admin,
  //           ...siteClearance.director,
  //           ...siteClearance.responsible,
  //           ...siteClearance.responsible,
  //         ],
  //       },
  //     },
  //     {
  //       path: 'newHiring',
  //       name: 'site-new-hiring',
  //       component: () => import('@views/hiring/new-hiring/new-hiring.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [
  //           ...siteClearance.admin,
  //
  //           ...siteClearance.director,
  //           ...siteClearance.responsible,
  //           ...siteClearance.responsible,
  //         ],
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/mx/:personnelDivision/rehiring',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  //   children: [
  //     {
  //       path: 'rehiringProcesses',
  //       name: 'site-rehiring-processes',
  //       component: () => import('@views/rehiring/rehiring-processes/rehiring-processes-site.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'getPersonalData/:collaboratorUuid',
  //       name: 'site-rehiring-get-personal-data',
  //       component: () => import('@views/rehiring/get-personal-data/get-personal-data.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'getAddressData/:collaboratorUuid',
  //       name: 'site-rehiring-get-address-data',
  //       component: () => import('@views/rehiring/get-address-data/get-address-data.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'getFiscalData/:collaboratorUuid',
  //       name: 'site-rehiring-get-fiscal-data',
  //       component: () => import('@views/rehiring/get-fiscal-data/get-fiscal-data.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'getBankData/:collaboratorUuid',
  //       name: 'site-rehiring-get-bank-data',
  //       component: () => import('@views/rehiring/get-bank-data/get-bank-data.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'getLaborData/:collaboratorUuid',
  //       name: 'site-rehiring-get-labor-data',
  //       component: () => import('@views/rehiring/get-labor-data/get-labor-data.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //   ],
  // },
  // ///////////////////
  // GUEST HIRING ROUTES, THROUGH INVITATION
  // //////////////////
  // {
  //   path: '/mx/guest',
  //   component: () => import('@views/empty-router-view.vue'),
  //   children: [
  //     {
  //       path: 'idTokenCheck/:token?',
  //       name: 'id-token-check',
  //       component: () => import('@views/hiring/id-token-check/id-token-check.vue'),
  //       meta: {
  //         authRequired: false,
  //         authorize: [],
  //       },
  //     },
  //     {
  //       path: ':personnelDivision',
  //       component: () => import('@views/empty-router-view.vue'),
  //       children: [
  //         {
  //           path: 'getPersonalData/:collaboratorUuid?',
  //           name: 'guest-hiring-get-personal-data',
  //           component: () => import('@views/guest-hiring/get-personal-data/get-personal-data.vue'),
  //           beforeEnter: (to, from, next) => {
  //             guestTokenMiddlware(next)
  //           },
  //           meta: {
  //             authRequired: false,
  //             authorize: [],
  //           },
  //         },
  //         {
  //           path: 'getAddressData/:collaboratorUuid',
  //           name: 'guest-hiring-get-address-data',
  //           component: () => import('@views/guest-hiring/get-address-data/get-address-data.vue'),
  //           beforeEnter: (to, from, next) => {
  //             guestTokenMiddlware(next)
  //           },
  //           meta: {
  //             authRequired: false,
  //             authorize: [],
  //           },
  //         },
  //         {
  //           path: 'getFiscalData/:collaboratorUuid',
  //           name: 'guest-hiring-get-fiscal-data',
  //           component: () => import('@views/guest-hiring/get-fiscal-data/get-fiscal-data.vue'),
  //           beforeEnter: (to, from, next) => {
  //             guestTokenMiddlware(next)
  //           },
  //           meta: {
  //             authRequired: false,
  //             authorize: [],
  //           },
  //         },
  //         {
  //           path: 'getBankData/:collaboratorUuid',
  //           name: 'guest-hiring-get-bank-data',
  //           component: () => import('@views/guest-hiring/get-bank-data/get-bank-data.vue'),
  //           beforeEnter: (to, from, next) => {
  //             guestTokenMiddlware(next)
  //           },
  //           meta: {
  //             authRequired: false,
  //             authorize: [],
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  // /////////////
  // LEAVE ROUTES
  // /////////////
  // {
  //   path: '/leave',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  //   children: [
  //     {
  //       path: 'openLeaveProcesses',
  //       component: () => import('@views/empty-router-view.vue'),
  //       children: [
  //         {
  //           path: '',
  //           name: 'open-leave-processes',
  //           component: () => import('@views/leave/open-process/open-leave-processes.vue'),
  //           meta: {
  //             authRequired: true,
  //             authorize: [...siteClearance.admin],
  //           },
  //         },
  //         {
  //           path: ':processUuid',
  //           name: 'open-leave-process-details',
  //           component: () => import('@views/leave/leave-process-details/leave-process-details.vue'),
  //           meta: {
  //             authRequired: true,
  //             authorize: [...siteClearance.admin],
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       path: ':collaboratorUuid',
  //       name: 'leave',
  //       component: () => import('@/router/views/leave/leave-form/leave-form.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //   ],
  // },
  // //////////////////
  // SITE LEAVE ROUTES
  // /////////////////
  // {
  //   path: '/mx/:personnelDivision/leave',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  //   children: [
  //     {
  //       path: 'openLeaveProcesses',
  //       component: () => import('@views/empty-router-view.vue'),
  //       children: [
  //         {
  //           path: '',
  //           name: 'site-open-leave-processes',
  //           component: () => import('@views/leave/open-process/site-open-leave-processes.vue'),
  //           meta: {
  //             authRequired: true,
  //             authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //           },
  //         },
  //         {
  //           path: ':processUuid',
  //           name: 'site-open-leave-process-details',
  //           component: () => import('@views/leave/leave-process-details/leave-process-details.vue'),
  //           meta: {
  //             authRequired: true,
  //             authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       path: ':collaboratorUuid',
  //       name: 'site-leave',
  //       component: () => import('@/router/views/leave/leave-form/leave-form.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //   ],
  // },
  // //////////////////
  // SITE MOBILITY FORM
  // /////////////////
  // {
  //   path: '/mobility',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'mobility-form',
  //       component: () => import('@/router/views/mobility/mobility-form/mobility-form.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //   ],
  // },
  // //////////////////
  // SITE MOBILITY DASHBOARD
  // /////////////////
  // {
  //   path: '/mobility-dashboard',
  //   component: () => import('@/router/views/mobility/mobility-form/mobility-dashboard.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // //////////////////
  // SITE LEAVE SURVEY
  // /////////////////
  // {
  //   path: '/leave-survey',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'site-leave-survey',
  //       component: () => import('@/router/views/leave/leave-form/leave-form-survey.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //   ],
  // },
  // //////////////////
  // SITE LEAVE SURVEY
  // /////////////////
  // {
  //   path: '/leave-survey-dashboard',
  //   component: () => import('@/router/views/leave/leave-form/leave-survey-dashboard.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // // //////////////////
  // // SITE LEAVE SURVEY
  // // /////////////////
  // {
  //   path: '/reports',
  //   component: () => import('@/router/views/planning/reports/reporte-altas.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // //////////////////
  // LEAVE PROCESS CHECK LIST OPTIONS ADMIN ROUTES
  // /////////////////
  // {
  //   path: '/leaveProcessCheckListOption',
  //   component: () => import('@views/empty-router-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'leave-process-check-list-options-list',
  //       component: () => import('@/router/views/leave/leave-process-check-list-options/leave-process-check-list-options-list.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //       },
  //     },
  //     {
  //       path: 'new',
  //       name: 'leave-process-check-list-options-create',
  //       component: () => import('@/router/views/leave/leave-process-check-list-options/leave-process-check-list-options-create.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director],
  //       },
  //     },
  //     {
  //       path: ':optionId',
  //       name: 'leave-process-check-list-options-update',
  //       component: () => import('@/router/views/leave/leave-process-check-list-options/leave-process-check-list-options-update.vue'),
  //       meta: {
  //         authRequired: true,
  //         authorize: [...siteClearance.admin, ...siteClearance.director],
  //       },
  //     },
  //   ],
  // },
  // //////////////////
  // ACCESS DEVICE FILES ADMIN ROUTES
  // /////////////////
  // {
  //   path: '/accessDeviceFiles',
  //   name: 'access-device-files',
  //   component: () => import('@views/accessDeviceFiles/access-device-files-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },

  // //////////////////
  // ACCESS DEVICE TIME SLOTS ADMIN ROUTES
  // /////////////////
  // {
  //   path: '/accessDeviceTimeSlots',
  //   name: 'access-device-time-slots',
  //   component: () => import('@views/accessDeviceTimeSlots/access-device-time-slots-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },

  // //////////////////
  // CONVERSION ROUTES
  // /////////////////
  // {
  //   path: '/conversions',
  //   name: 'conversions-list',
  //   component: () => import('@views/collaborator/collaborator-conversion/collaborator-conversion-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/conversions',
  //   name: 'site-conversions-list',
  //   component: () => import('@views/collaborator/collaborator-conversion/collaborator-conversion-site-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/conversion/:collaboratorUuid',
  //   name: 'conversion',
  //   component: () => import('@views/conversion/conversion-form/conversion-form.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/conversion/:id',
  //   name: 'site-conversion',
  //   component: () => import('@views/conversion/conversion-form/conversion-form.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // //////////////////
  // EXTENSION ROUTES
  // /////////////////
  // {
  //   path: '/extensions',
  //   name: 'extensions-list',
  //   component: () => import('@views/collaborator/collaborator-extension/collaborator-extension-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/extensions',
  //   name: 'site-extensions-list',
  //   component: () => import('@views/collaborator/collaborator-extension/collaborator-extension-site-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/extension/:collaboratorUuid',
  //   name: 'contract-extension',
  //   component: () => import('@views/contract/contract-extension.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/extension/:collaboratorUuid',
  //   name: 'site-contract-extension',
  //   component: () => import('@views/contract/contract-extension.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // //////////////////
  // HOUR CHANGES ROUTES
  // /////////////////
  // {
  //   path: '/timebaseChange/:collaboratorId',
  //   name: 'collaborator-hour-change',
  //   component: () => import('@/router/views/laborCondition/hour-change/hour-change-process.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/timebaseChange/:collaboratorId',
  //   name: 'collaborator-hour-change-site',
  //   component: () => import('@/router/views/laborCondition/hour-change/hour-change-process.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/timebaseChangeProcesses',
  //   name: 'timebase-change-processes-list',
  //   component: () => import('@/router/views/laborCondition/hour-change/timebase-change-processes-list.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },
  // {
  //   path: '/mx/:personnelDivision/timebaseChangeProcesses',
  //   name: 'timebase-change-processes-list-site',
  //   component: () => import('@/router/views/laborCondition/hour-change/timebase-change-processes-list-site.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin, ...siteClearance.director,   ...siteClearance.responsible],
  //   },
  // },
  // {
  //   path: '/mx/timebaseChangeProccesses/:processUuid/document',
  //   name: 'timebase-change-process-document',
  //   component: () => import('@/router/views/laborCondition/document/timebase-change-document-view.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [
  //       ...siteClearance.admin,

  //       ...siteClearance.director,
  //       ...siteClearance.responsible,
  //       ...siteClearance.collaborator,
  //     ],
  //   },
  // },
  // ////////////////////////
  // FEATURE TOGGLE ROUTES
  // ////////////////////////
  // {
  //   path: '/featureToggle',
  //   name: 'feature-toggle',
  //   component: () => import('@views/admin/feature-toggle/feature-toggle.vue'),
  //   meta: {
  //     authRequired: true,
  //     authorize: [...siteClearance.admin],
  //   },
  // },

  // ///////////
  // AUTH ROUTES
  // ///////////
  {
    path: '/login',
    alias: '/loginFedId',
    name: 'login',
    component: () => import('@views/auth/login-view.vue'),
    beforeEnter: federatedLoginGuard,
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@views/auth/logout-view.vue'),
    meta: {
      authRequired: true,
      authorize: [],
      beforeResolve(routeTo, routeFrom, next) {
        store
          .dispatch('auth/logOut')
          .then(() => {
            next()
          })
          .catch((error) => console.warn(error))
      },
    },
  },
  {
    path: '/welcomeNewCollaborator',
    name: 'welcomeNewCollaborator',
    component: () => import('@views/hiring/welcome-new-collaborator.vue'),
    meta: {
      authRequired: false,
      authorize: [],
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/:catchAll(.*)*',
    redirect: '404',
  },
]

// function guestTokenMiddlware(next) {
//   if (store.state.contractManager.verifyInvitationData.token === '') {
//     next({ path: '/mx/guest/idTokenCheck' })
//   } else {
//     next()
//   }
// }
